import { fetch } from '../../api';
import { fetchFeed, fetchNewsFeed } from './general';
import feedNaming from '../../utils/feedNaming';


export function fetchFollowers(id, from, pageSize = 20) {
  const feed = { id: feedNaming.users.followers(id), dataType: 'users', hasMore: false };
  const pageNumber = Math.ceil(from / pageSize) + 1;

  const fetchData = async function fetchData() {
    const { payload = {} } = await fetch('user/followers', { query: { pageNumber, pageSize, id } });
    const { userInfo: users = {} } = payload;
    return { data: { users } };
  };

  return fetchFeed(feed, from === 0, fetchData);
}

export function fetchPosts(userId, currentId, from, pageSize = 20) {
  const feed = { id: feedNaming.users.posts(userId), dataType: 'posts' };
  const pageNumber = Math.ceil(from / pageSize) + 1;

  const fetchData = async function fetchData() {
    const { payload } = await fetch(
      'posts',
      { query: { pageNumber, pageSize, userId } }
    );
    const { posts, users, ratings, groups } = payload;
    return { data: { posts, users, ratings, groups } };
  };

  return fetchFeed(feed, from === 0, fetchData);
}

export function fetchReplies(id, from, pageSize = 20) {
  const feed = { id: feedNaming.users.replies(id), dataType: 'posts' };
  const pageNumber = Math.ceil(from / pageSize) + 1;

  const fetchData = async function fetchData() {
    const { payload } = await fetch(
      'activity',
      { query: { pageNumber, pageSize, id, filter: 'user-activity-public' } }
    );
    const { groups, users, result } = payload;
    const posts = result.hits.hits.map(u => {
      const postData = u._source;
      return {
        ...postData,
        superParent: {
          ...postData.superParent,
          groupId: postData.groupId,
        },
      };
    });
    return { data: { groups, users, posts } };
  };

  return fetchFeed(feed, from === 0, fetchData);
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/profile.js